<template >
  <div class="bodyback">
    <notifications></notifications>

    <div class="main-content mt-0">
      <div class="overimg"></div>

      <div class="container pb-0 pt-5m min-vh-100">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-7 pt-6">
            <div class="card card-alerts card-success" v-if="result">
              <div class="card-header">
                <div class="text-dark text-center">
                  <img src="/img/icons/alerts/success.png" alt="" />
                  <h2>Success!</h2>
                </div>
              </div>
              <div class="card-body px-lg-4 text-center">
                <p class="p-content-card">
                  The authentication
                  <span class="font-weight-600 text-lg d-block"></span>
                  has been
                  <span class="strong"> generated correctly.</span>
                </p>
                <hr />
                <p class="p-content-min">
                  You can close this window or wait {{ time }} seconds for it to
                  close automatically
                </p>

                <div class="loading mt-3" v-if="load">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
              </div>
            </div>

            <div class="card card-alerts card-danger" v-else>
              <div class="card-header">
                <div class="text-dark text-center">
                  <img src="/img/icons/alerts/error.png" alt="" />
                  <h2>Error!</h2>
                </div>
              </div>
              <div class="card-body px-lg-4 text-center">
                <p class="p-content-card">
                  Sorry, an error occurred while an error occurred while
                  authenticating. <br />
                  <span class="strong">Please try again.</span>
                </p>

                <hr />
                <p class="mb-0 p-content-card">
                  If the error persists, please contact us
                  <a href="mailto:info@rhomtrip.com">info@rhomtrip.com</a>
                </p>

                <hr />
                <p class="p-content-min">
                  You can close this window or wait {{ time }} seconds for it to
                  close automatically
                </p>

                <div class="loading mt-3" v-if="load">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "auth-validation",
  data() {
    return {
      time: 3,
      result: "",
      load: true,
    };
  },
  created() {
    if (this.$route.query.result) {
      this.result = this.$route.query.result === "successful" ? true : false;
    }
    setInterval(() => {
      this.time = this.time - 1;
      if (this.time === 0) {
        window.close();
      }
    }, 1000);
  },
};
</script>
                    